import { useEffect, useState } from 'react';

/**
 * Theme manager — light / dark, persisted to localStorage.
 * Sets data-theme on <html> so CSS variables can switch.
 *
 *   const { theme, toggle } = useTheme();
 *   <button onClick={toggle}>{theme === 'dark' ? '☀️' : '🌙'}</button>
 */
const KEY = 'theme';

function getInitial() {
  if (typeof window === 'undefined') return 'light';
  const saved = localStorage.getItem(KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  // Honour OS preference for first-time visitors
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
}

export default function useTheme() {
  const [theme, setTheme] = useState(getInitial);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem(KEY, theme); } catch (_) {}
  }, [theme]);

  return {
    theme,
    setTheme,
    toggle: () => setTheme(t => (t === 'dark' ? 'light' : 'dark')),
  };
}
